import { DashboardLayout } from "components/DashboardLayout";
import { Button } from "components/DesignSystem/Button/Button";
import { LockedButton } from "components/DesignSystem/Button/LockedButton";
import { Header } from "components/DesignSystem/Header/Header";
import { LockedUi } from "components/LockedUi/LockedUi";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { CustomReportsGrids } from "./CustomReportsGrids";
import { useCustomReports } from "./useCustomReports";

export const CustomReports = () => {
  const customReports = useCustomReports();

  return (
    <DashboardLayout
      header={
        <Header
          v2
          title="Custom Reports"
          right={
            <LockedUi
              feature={WRITE_PERMISSION_KEYS.FINANCIALS}
              blockedUi={<LockedButton text="Create new" />}
            >
              <Button
                customType="primary"
                size="small"
                onClick={customReports.handleCreateNew}
                isLoading={customReports.isCreating}
              >
                Create new
              </Button>
            </LockedUi>
          }
        />
      }
    >
      <CustomReportsGrids {...customReports} />
    </DashboardLayout>
  );
};
